export const CopyRightText = ', Made by ';
export const CopyRightIcon = '© ';
export const GI = 'Grazitti';
export const DropdownListText = ['Dashboard', 'Profile', 'Global Settings', 'Logout'];
export const GRIGOText = 'GRIGO';
export const FooterLinks = [
  { label: 'Privacy Policy', link: 'https://www.grazitti.com/privacy-policy/' },
  { label: 'Terms & Conditions', link: 'https://www.grazitti.com/legal/terms-and-conditions/' },
  { label: 'Help Center', link: 'https://jira.grazitti.com/projects/GHD/summary' },
];
export const SupportText = 'Support';
